import React from 'react';
import {reportsDataMapper, reportsTotalMapper} from './my-reports.mappers';
import {isSuccessResponse} from 'shared';
import http from 'service/api';
import {Api} from 'settings';

export const loadingReportsAction = (payload) => ({type: 'LOADING_REPORTS', payload});
export const loadReportsAction = (payload) => ({type: 'LOAD_REPORTS', payload});
export const updateReportAction = (payload) => ({type: 'UPDATE_REPORT', payload});
export const loadMoreReportsAction = (payload) => ({type: 'LOAD_MORE_REPORTS', payload});
export const searchReportsAction = (payload) => ({type: 'SEARCH_REPORTS', payload});
export const updateCreatorFilterAction = (payload) => ({type: 'UPDATE_CREATOR_BY_FILTER', payload});
export const resetMyReportsAction = (payload) => ({type: 'RESET_MY_REPORTS', payload});

export const simulateProgressReportAction = (payload) => ({type: 'SIMULATE_PROGRESS', payload});

export const fetchReportsByCreatorAction = filterBy => {
  return async (dispatch, getState) => {
    dispatch(updateCreatorFilterAction({filterBy}));
    dispatch(fetchReports())
  };
}

const filterByCreatorStrategies = {
  'ALL': email => ({
    "should": [
      {"term": {"creator": email}},
      {"term": {"beneficiario": email}}
    ]
  }),
  'REPORT_REQUEST_BY_ME': email => ({
    "must": [{"term": {"creator": email}}]
  }),
  'MY_REPORT_REQUEST': email => ({
    "must": [{"term": {"beneficiario": email}}]
  }),
};

export const fetchReports = () => {
  return async (dispatch, getState) => {
    const isAuthenticated = getState().authReducers.isAuthenticated;
    const user = getState().authReducers.user;
    if (!isAuthenticated) return;

    const {loading, loadedAmount, total, filterByCreatorActive: filterByCreator} = getState().myReportsReducers;

    if (loading) return;
    if (loadedAmount !== 0 && loadedAmount >= total) return;

    const filterByCreatorActive = filterByCreator
      ? filterByCreatorStrategies[filterByCreator](user.email)
      : filterByCreatorStrategies.ALL(user.email);

    try {
      dispatch(loadingReportsAction(true));
      const response = await http.post(
        Api.reportList(loadedAmount),
        {
          "bool": {
            ...filterByCreatorActive,
            "must_not": [
              {"term": {"deleted": true}},
              {"match_phrase": {"duplicated_for": user.email}}
            ]
          }
        },
        {target: 'alf'}
      );

      if (isSuccessResponse(response)) {
        return dispatch(
          loadReportsAction({
            data: reportsDataMapper(response.data),
            total: reportsTotalMapper(response.data)
          })
        )
      }
    } catch (e) {
      console.log(e);
    }
    dispatch(loadingReportsAction(false));
  }
};


